<template>
    <div class="reports-page-2023" :style="'height:'+ Cheight+'px'">


        <van-card :thumb="JOA_URL+'images/user/'+ADMIN.USER_CODE+'.jpg'" class="user-image">
            <div slot="title">
                <div class="name">{{ADMIN.USER_NAME}}</div>
            </div>
            <div class="desc" slot="desc">
                <span>工号：{{ADMIN.USER_CODE}}</span>
                <span>{{getToday()}}</span>
            </div>
        </van-card>

        <div class="oa-report-item-box">
            <div class="oa-report-item oa-report-up">
                <div class="info">
                    <div>
                        <div class="icon">
                            <span class="iconSass sass-shangwu"></span>
                        </div>
                        <div class="title">
                            上班打卡
                        </div>
                        <div class="time">{{UpTime}}</div>
                    </div>
                    <div class="ok-icon" v-if="UpTime">
                        <span class="iconSass sass-chenggong"></span>
                    </div>
                </div>
                <div class="address">
                    <span class="iconSass sass-dingwei"></span>
                    <span>{{UpAddress}}</span>
                </div>

            </div>

            <div class="oa-report-item oa-report-dowm">
                <div class="info">
                    <div>
                        <div class="icon">
                            <span class="iconSass sass-xiawu"></span>
                        </div>
                        <div class="title">
                            下班打卡
                        </div>
                        <div class="time">{{DownTime}}</div>
                    </div>
                    <div class="ok-icon" v-if="DownTime">
                        <span class="iconSass sass-chenggong"></span>
                    </div>
                </div>
                <div class="address">
                    <span class="iconSass sass-dingwei"></span>
                    <span>{{DownAddress}}</span>
                </div>

            </div>
        </div>


        <div class="oa-report-position">
            <div class="oa-report-refresh" v-if="hasDistance2023" @click="onReplay">
                <div class="time">{{nowTime}}</div>
                <div class="text">刷新定位</div>
            </div>
            <div class="oa-report-punch" v-if="!hasDistance2023 && myplaceCurrent" @click="onConfirmPunch">
                <div class="time">{{nowTime}}</div>
                <span class="iconSass sass-dianji"></span>
            </div>
        </div>

        <div class="oa-report-address" v-if="myplaceCurrent">
            <span class="iconSass sass-dingwei"></span>
            <span>{{myplaceCurrent}}</span>
            <span v-if="hasDistance2023">(距离还有{{parseInt(distance)}}米)</span>
            <span v-if="!hasDistance2023" class="iconSass" @click="onReplay" style="margin: 0 2px;position: relative;top: 3px;"><van-icon name="replay" /></span>
        </div>


        <!-- 打卡弹框 -->
        <van-dialog
                class="punch"
                v-model="is_show"
                confirm-button-text="继续打卡"
                show-cancel-button
                @confirm="onPunch(1)"
        >
            <div class="punch-title" slot="title">
                <van-icon name="warning-o"/>
                <p>打卡提示</p></div>
            <div class="punch-warning">
                <div>
                    <p class="punch-txt">下班</p>
                    <p class="punch-time">17：00</p>
                </div>
            </div>
            <div class="punch-desc">还没到下班时间呢，亲确定要下班打卡吗？</div>
        </van-dialog>


        <div id="closeshowpunch">
            <van-popup
                    class="close-tip"
                    closeable
                    close-icon="close"
                    close-icon-position="top-right"
                    v-model="is_close_punch"
                    :style="{ height: '300px',width: '300px'}">
                <div class="van-toast van-toast--middle">
                    <i class="van-icon van-icon-success van-toast__icon"></i>
                    <div class="van-toast__text">打卡成功</div>
                </div>
            </van-popup>
        </div>


        <div id="tip-show" style="display: none;">
            <p id="longitude"></p>
            <p id="latitude"></p>
            <p id="address"></p>
            <p id="province"></p>
            <p id="city"></p>
            <p id="district"></p>
            <p id="road"></p>
        </div>

        <Loading v-if="loading"></Loading>

        <!--<div style="position: absolute; display: none">
            punchConfig_list: {{punchConfig_list}}<br>
            hasDistance2023：{{hasDistance2023}}<br>
            myplaceCurrent：{{myplaceCurrent}}<br>
            wx_location：{{wx_location}}<br>
            distance：{{distance}}
        </div>-->
    </div>
</template>

<script>
    import axios from 'axios'

    //经纬度计算
    function LngLat(longitude, latitude) {
        this.longitude = longitude;
        this.latitude = latitude;
    }

    import Loading from '@/components/loadingAa';

    export default {
        components: {Loading},
        data() {
            return {
                loading: false,
                OA_URL: this.CoreNew.OA_URL,
                JOA_URL: this.CoreNew.JOA_URL,
                WEB_URL: this.CoreNew.WEB_URL,
                OA_API_IP: this.CoreNew.OA_API_IP,
                NEW_OA_API_URL: this.CoreNew.NEW_OA_API_URL,
                QWXAPPID: this.CoreNew.QWXAPPID,
                ADMIN: JSON.parse(localStorage.getItem('LS_ADMIN')),

                UpTime: '',                     // 上班时间
                UpAddress: '',
                DownTime: '',                   // 下班时间
                DownAddress: '',

                nowTime: '',                    // 当前时间
                distance: 0,                    // 距离
                hasDistance2023: true,          // 当前定位距离打开还有距离
                myplaceCurrent: '',             // 当前定位

                punchConfig_list: [],           // 获取移动打卡配置
                wx_location: '',                // longitude 纬度  latitude 经度
                MAP_data: {},                   // 定位数据

                isGmap: false,                  // 定位是否成功

                is_show: false,                  // 打卡弹框
                is_close_punch: false,            // 打卡成功提示

                // 定位详情
                currentLocation: {
                    longitude: '',
                    latitude: '',
                    address: '',
                    province: '',
                    city: '',
                    district: '',
                    road: '',
                },
                Cheight:0,
            }
        },
        mounted() {
            this.Cheight = document.documentElement.clientHeight || document.body.clientHeight
            // 公司打卡位置
            this.getPunchConfig()

            this.loading = true
            // 获取 纬度 经度
            this.getMap()

            this.getNowTime()

            // 刷新时间
            setInterval(() => {
                this.getNowTime()
            }, 1000)


            // 获取是否有打卡记录
            setTimeout(() => {
                this.getQueryPunch()
            }, 300)

            // 自动刷新定位
            setInterval(() => {
                if(this.myplaceCurrent) {
                    // 获取 纬度 经度
                    this.getMap()
                }
            }, 1000 * 10)

        },
        methods: {
            // 格式化时间
            JStoTimeHFM(times) {
                var timearr = times.replace(" ", ":").replace(/\:/g, "-").split("-");
                if (parseInt(timearr[3]) < 10 && timearr[3].length == 1) {
                    var timestr = "0" + timearr[3] + ":" + timearr[4] + ":" + timearr[5];
                } else {
                    var timestr = "" + timearr[3] + ":" + timearr[4] + ":" + timearr[5];
                }
                return timestr;
            },
            // 获取今天
            getToday() {
                let yy = new Date().getFullYear();
                let mm = new Date().getMonth() + 1;
                if (mm < 10) {
                    mm = "0" + mm;
                }
                let dd = new Date().getDate();
                if (dd < 10) {
                    dd = "0" + dd;
                }
                return yy + "-" + mm + "-" + dd;
            },
            // 获取当前时间
            getNowTime() {
                let hh = new Date().getHours() < 10 ? '0' + new Date().getHours() : new Date().getHours();
                let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
                let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
                this.nowTime = hh + ':' + mf + ':' + ss;
            },

            // 公司打卡位置
            getPunchConfig() {
                const that = this
                let post_data = new FormData();
                post_data.append("userName", JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')));

                axios.post(this.OA_API_IP + "joa-business/mobile/queryPunchConfig", post_data, {
                    headers: {'Authorization': JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
                }).then(function (response) {
                    if (response.data.flag == true && response.data.data) {
                        that.punchConfig_list = response.data.data;
                    } else {
                        that.$toast("获取不到打卡配置或者配置为空")
                    }
                })
            },

            // 获取 纬度 经度
            getMap() {
                let redirect_url = encodeURIComponent(window.location.href); //当前url
                let that = this
                // this.loading = true
                // $('#loading').show();
                axios.get(this.NEW_OA_API_URL + "api/wechatwork/basic/common/signature?url=" + redirect_url, {
                    headers: {'Authorization': JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
                }).then(function (response) {
                    console.log('getMap----------')
                    console.log(response)
                    var rs = response.data;
                    if (rs.code == 200) {
                        const wx_appId = that.QWXAPPID;
                        const wx_timeStamp = rs.data.timestamp;
                        const wx_nonceStr = rs.data.nonceStr;
                        const wx_signature = rs.data.signature;

                        wx.config({
                            debug: false,
                            appId: wx_appId,
                            timestamp: wx_timeStamp,
                            nonceStr: wx_nonceStr,
                            signature: wx_signature,
                            jsApiList: [
                                'getLocation'
                            ]
                        });
                        wx.ready(function () {
                            wx.getLocation({
                                type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                                success: function (res) {
                                    var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
                                    var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
                                    //var speed = res.speed; // 速度，以米/每秒计
                                    //var accuracy = res.accuracy; // 位置精度

                                    that.wx_location = longitude + "," + latitude

                                    that.getAddress_map(that.wx_location)
                                }
                            });
                        });
                    }
                })
            },


            // qq.maps 获取定位
            getAddress_map(user_location) {
                let that = this
                if (user_location) {
                    var data = user_location.split(',');
                    var lng = data[0];
                    var lat = data[1];
                    var geocoder, map, lnglat = null;
                    //lnglat = new qq.maps.LatLng(22.541418,114.047871);

                    lnglat = new qq.maps.LatLng(lat, lng);
                    map = new qq.maps.Map('container', {
                        center: lnglat,
                        zoom: 12,
                    });

                    //地址和经纬度之间进行转换服务
                    geocoder = new qq.maps.Geocoder();
                    //设置服务请求成功的回调函数
                    geocoder.setComplete(function (result) {
                        map.setCenter(result.detail.location);
                    });
                    //若服务请求失败，则运行以下函数
                    geocoder.setError(function () {
                        // alert("获取定位错误");
                        that.isGmap = false
                        that.getAddress()
                    });
                    var tmp_punchConfig_list = that.punchConfig_list;
                    localStorage.setItem('MAP_punchConfig_list', JSON.stringify(tmp_punchConfig_list));
                    //var WX_VUE=this;
                    geocoder = new qq.maps.Geocoder({
                        complete: function (result) {
                            // console.log('获取定位成功');
                            // console.log(result);
                            // console.log(result.detail.address);
                            var data = result.detail;
                            data["longitude"] = lng;
                            data["latitude"] = lat;
                            //data["longitude"]="114.000222";
                            //data["latitude"]="22.58936";
                            localStorage.setItem('MAP_data', JSON.stringify(data));

                            that.MAP_data = data
                            that.isGmap = true
                            that.getAddress()
                        }
                    });
                    geocoder.getAddress(lnglat);

                }
            },


            //
            getAddress() {
                if (this.isGmap) {
                    let that = this
                    var punchConfig_list = this.punchConfig_list
                    var data = this.MAP_data

                    var is_location = false;
                    for (var i = 0; i < punchConfig_list.length; i++) {
                        is_location = that.makePunch(data, punchConfig_list[i].BASELONGITUDE, punchConfig_list[i].BASELATITUDE, punchConfig_list[i].BASEACCURACY, i, punchConfig_list.length);
                        console.log("员工打卡地址" + i);
                        if (is_location == true) {
                            break;
                        }
                    }


                    //定位成功，震动效果
                    if (window.navigator && window.navigator.vibrate) {
                        console.log("你的浏览器支持调用手机震动");
                        window.navigator.vibrate(300);
                    } else {
                        console.log("你的浏览器不支持调用手机震动");
                    }
                } else {
                    this.$dialog.alert({
                        message: '定位异常，请稍后再试',
                        showConfirmButton: true
                    });
                }
            },

            makePunch(data, company_Lng, company_Lat, company_Distance, locations_active, locations_length) {
                let that = this
                var myplace = ''; //我的位置
                var mycity = ''; //我所在的城市


                const addressComponents = data.addressComponents
                if (addressComponents) {
                    //我的位置
                    myplace = addressComponents.province + addressComponents.city + addressComponents.district + addressComponents.town + addressComponents.street + addressComponents.streetNumber;

                    //我所在的城市
                    mycity = addressComponents.city;

                    that.currentLocation.province = addressComponents.province ? addressComponents.province : ''
                    that.currentLocation.city = addressComponents.city
                    that.currentLocation.district = addressComponents.district
                    that.currentLocation.road = addressComponents.street + addressComponents.streetNumber

                }

                if (mycity == "") { //避免获取不到城市
                    if (myplace != "") {
                        mycity = myplace.substr(0, 3);
                    }
                }
                that.myplaceCurrent = myplace


                that.currentLocation.longitude = data.longitude
                that.currentLocation.latitude = data.latitude
                that.currentLocation.address = myplace


                // 经纬度计算
                var start = new LngLat(data.longitude, data.latitude);
                var end = new LngLat(company_Lng, company_Lat);  //公司地址

                // 计算距离
                const distance = that.calculateLineDistance(start, end);
                that.distance = distance

                if (distance > company_Distance) {
                    that.hasDistance2023 = true
                } else {
                    that.hasDistance2023 = false
                }
                that.loading = false
                // $('#loading').hide();
                localStorage.setItem('LS_ADRESS', JSON.stringify(myplace));
                localStorage.setItem('LS_CITY', JSON.stringify(mycity));

            },

            // 计算距离
            calculateLineDistance(start, end) {
                var d1 = 0.01745329251994329;
                var d2 = start.longitude;
                var d3 = start.latitude;
                var d4 = end.longitude;
                var d5 = end.latitude;
                d2 *= d1;
                d3 *= d1;
                d4 *= d1;
                d5 *= d1;
                var d6 = Math.sin(d2);
                var d7 = Math.sin(d3);
                var d8 = Math.cos(d2);
                var d9 = Math.cos(d3);
                var d10 = Math.sin(d4);
                var d11 = Math.sin(d5);
                var d12 = Math.cos(d4);
                var d13 = Math.cos(d5);
                var arrayOfDouble1 = [];
                var arrayOfDouble2 = [];
                arrayOfDouble1.push(d9 * d8);
                arrayOfDouble1.push(d9 * d6);
                arrayOfDouble1.push(d7);
                arrayOfDouble2.push(d13 * d12);
                arrayOfDouble2.push(d13 * d10);
                arrayOfDouble2.push(d11);
                var d14 = Math.sqrt((arrayOfDouble1[0] - arrayOfDouble2[0]) * (arrayOfDouble1[0] - arrayOfDouble2[0]) +
                    (arrayOfDouble1[1] - arrayOfDouble2[1]) * (arrayOfDouble1[1] - arrayOfDouble2[1]) +
                    (arrayOfDouble1[2] - arrayOfDouble2[2]) * (arrayOfDouble1[2] - arrayOfDouble2[2]));
                return (Math.asin(d14 / 2.0) * 12742001.579854401);
            },

            // 获取是否有打卡记录
            getQueryPunch() {
                let that = this
                let post_data = new FormData();
                post_data.append("userName", JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')));
                axios.post(this.OA_API_IP + "joa-business/mobile/queryPunch", post_data, {
                    headers: {'Authorization': JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
                }).then(function (response) {
                    if (response.data.flag == true) {
                        var $res = JSON.parse(response.data.data);

                        if ($res.UpTime.indexOf('无') == -1) {
                            that.UpTime = that.JStoTimeHFM($res.UpTime)
                            that.UpAddress = $res.UpAddress
                        } else {
                            that.UpTime = ''
                            that.UpAddress = ''
                        }

                        if ($res.DownTime.indexOf('无') == -1) {
                            that.DownTime = that.JStoTimeHFM($res.DownTime)
                            that.DownAddress = $res.DownAddress
                        } else {
                            that.DownTime = ''
                            that.DownAddress = ''
                        }
                    }
                })

            },

            // 刷新
            onReplay() {
                // 获取 纬度 经度
                this.loading = true
                this.getMap()
            },

            // 操作时间
            getTimeHFM() {
                let hh = new Date().getHours() < 10 ? "0" + new Date().getHours() : new Date().getHours();
                let mf = new Date().getMinutes() < 10 ? "0" + new Date().getMinutes() : new Date().getMinutes();
                let ss = new Date().getSeconds() < 10 ? "0" + new Date().getSeconds() : new Date().getSeconds();
                return hh + ":" + mf + ":" + ss;
            },

            // 打卡
            onConfirmPunch() {
                const hour = new Date().getHours();
                // type 0 上班 1 下班
                let type = 0

                const UpTime = this.UpTime
                const DownTime = this.DownTime

                // 上班已打卡
                if (UpTime) {
                    type = 1
                }

                // 已上班打卡 下班打卡未到点提示
                if (UpTime && hour < 17) {
                    this.is_show = true;
                    return
                }


                this.onPunch(type)
            },


            onPunch(punchtype) {
                let that = this
                // var HFMtime = this.getTimeHFM();//操作时间
                this.is_show = false;
                // $("#loading").show();
                this.loading = true
                //触发打卡
                let post_data = new FormData();
                post_data.append("workPunchTypeDb", punchtype); //0上班，1下班
                post_data.append("sourceType", 1);//PC:0,微信:1,钉钉:2
                post_data.append("userName", JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')));
                post_data.append("uuid", JSON.parse(localStorage.getItem('LS_QWX_DEVICEID')));//设备号
                post_data.append("macIp", "");
                post_data.append("longitude", this.currentLocation.longitude);
                post_data.append("latitude", this.currentLocation.latitude);
                post_data.append("accuracy", 25);
                post_data.append("address", this.currentLocation.address);
                post_data.append("province", this.currentLocation.province);
                post_data.append("city", this.currentLocation.city);
                post_data.append("district", this.currentLocation.district);
                post_data.append("road", this.currentLocation.road);
                post_data.append("netType", "");
                post_data.append("operatorType", "");


                axios.post(this.OA_API_IP + "joa-business/mobile/savePunch", post_data, {
                    headers: {'Authorization': JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
                }).then(function (response) {
                    // $("#loading").hide();

                    that.loading = false
                    if (response.data.flag == true) {
                        that.is_close_punch = true;
                        that.getQueryPunch()

                        setTimeout(() => {
                            that.is_close_punch = false;
                        }, 3000);
                    }
                })

            }
        }
    }
</script>
